import { Button, Form, Input, message } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import styles from './Faq.module.css'

// REDUX
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../../redux/user/user.selectors'
import { removeCurrentUser } from '../../../../redux/user/user.action'

import { useNavigate, useParams } from 'react-router-dom'
import { FetchLoading } from '../../../../components'

message.config({
  maxCount: 1,
})

const FaqForm = ({ title = '' }) => {
  const [loading, setLoading] = useState(true)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [faqData, setFaqData] = useState(null)
  const { slug } = useParams()

  const navigate = useNavigate()
  const currentUser = useSelector(selectCurrentUser)
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  useEffect(() => {
    if (slug) {
      axios({
        method: 'get',
        url: `/faq/${slug}`,
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      })
        .then(({ data }) => {
          setFaqData(data[0])
          setLoading(false)
        })
        .catch((error) => {
          if (error.response.status === 404) {
            message.error('404 Not Found')
          }
          if (error.response.status === 401) {
            message.error('401 Unauthorized')
            dispatch(removeCurrentUser())
            navigate('/login')
          }
          if (error.response.status === 500) {
            message.error('500 Internal Server Error')
          }
          if (error.response.status === 403) {
            message.error('403 Forbidden')
          }
        })
    } else {
      setLoading(false)
      setFaqData({ question: '', answer: '' })
    }
  }, [currentUser.token, dispatch, navigate, slug])

  const onFinish = (values) => {
    setSubmitLoading(true)
    const { question, answer } = values
    const data = JSON.stringify({
      question,
      answer,
    })
    if (slug) {
      axios({
        method: 'patch',
        url: `/faq/${slug}`,
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
          'Content-Type': 'application/json',
        },
        data: data,
      })
        .then(() => {
          form.resetFields()
          message.success('FAQ Berhasil DiUpdate')
          navigate('/faq')
        })
        .catch((error) => {
          if (error.response.status === 404) {
            message.error('404 Not Found')
          }
          if (error.response.status === 401) {
            message.error('401 Unauthorized')
            dispatch(removeCurrentUser())
            navigate('/login')
          }
          if (error.response.status === 500) {
            message.error('500 Internal Server Error')
          }
          if (error.response.status === 403) {
            message.error('403 Forbidden')
          }
        })
    } else {
      axios({
        method: 'post',
        url: '/faq',
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
          'Content-Type': 'application/json',
        },
        data: data,
      })
        .then(() => {
          form.resetFields()
          message.success('FAQ Berhasil Ditambah')
          navigate('/faq')
        })
        .catch((error) => {
          if (error.response.status === 404) {
            message.error('404 Not Found')
          }
          if (error.response.status === 401) {
            message.error('401 Unauthorized')
            dispatch(removeCurrentUser())
            navigate('/login')
          }
          if (error.response.status === 500) {
            message.error('500 Internal Server Error')
          }
          if (error.response.status === 403) {
            message.error('403 Forbidden')
          }
        })
    }
  }

  return (
    <FetchLoading data={faqData}>
      <div className={styles.container}>
        <div className={styles.card}>
          <h1 className={styles.title}>{title}</h1>
          {!loading && (
            <Form
              form={form}
              layout={'vertical'}
              onFinish={onFinish}
              initialValues={{
                question: faqData.question,
                answer: faqData.answer,
              }}>
              <Form.Item
                label="Question"
                name="question"
                rules={[
                  {
                    required: true,
                    message: 'Question belum di isi!',
                  },
                ]}>
                <Input.TextArea autoSize={{ minRows: 5, maxRows: 5 }} />
              </Form.Item>
              <Form.Item
                label="Answer"
                name="answer"
                rules={[
                  {
                    required: true,
                    message: 'Answer belum di isi!',
                  },
                ]}>
                <Input.TextArea autoSize={{ minRows: 5, maxRows: 5 }} />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={submitLoading}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          )}
        </div>
      </div>
    </FetchLoading>
  )
}

export default FaqForm
